import { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "react-toastify";
import { otpVerifyHandler } from "../../../service/AuthService";

const OtpVerifyForm = ({ onFormChange }) => {
  
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);

  const email = localStorage.getItem("forgotPasswordEmail");

  const handleOtpVerify = async () => {
    const otpNumber = otp.join("");
    if (!otpNumber) {
      toast.error("Please enter your OTP");
      return;
    }
    setIsLoading(true);
    try {
      await otpVerifyHandler(email, otpNumber); 
      onFormChange("resetPassword");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleBack = () => {
    onFormChange("forgotPassword");
  };
  return (
    <div class="my-auto mx-auto flex flex-col justify-center px-6 pt-8 md:justify-start lg:w-[28rem]">
      <p class="text-center text-3xl font-bold md:text-left md:leading-tight">
        OTP Verification
      </p>
      <p class="mt-2 text-center text-gray-500 font-medium md:text-left">
        Enter your Otp for verify and reset your password.
      </p>

      <div class="flex flex-col items-stretch pt-3 md:pt-8">
        <div class="flex flex-col pt-6">
          <div className="flex flex-col space-y-16">
            <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xs">
              {[1, 2, 3, 4].map((index) => (
                <div key={index} className="w-16 h-16 ">
                  <input
                    className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-gray-800"
                    type="text"
                    value={otp[index - 1] || ""}
                    onChange={(e) => {
                      const updatedOtp = [...otp];
                      updatedOtp[index - 1] = e.target.value;
                      setOtp(updatedOtp);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mt-5">
          <IoMdArrowRoundBack
            className="mt-6 text-2xl text-gray-400 cursor-pointer"
            onClick={handleBack}
          />
          <button
            className="mt-6  rounded-lg bg-gray-800 px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-gray-500 ring-offset-2 transition hover:bg-gray-900 focus:ring-2 md:w-32"
            onClick={handleOtpVerify}
          >
            {isLoading ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerifyForm;
